<template>
  <div id="app">
    <Musica/>
  </div>
</template>

<script>
import Musica from './components/Musica.vue'

export default {
  name: 'App',
  components: {
    Musica
  }
}
</script>

